import Request from '../../data/request'

// @ts-ignore
import ApiStripe from "./stripe";
// @ts-ignore
import ApiIntegrationGCal from "./gcal";
import ApiIntegrationGoogleDrive from "./google-drive";

export default class ApiIntegrations {

    public Stripe       : ApiStripe
    public GCal       : ApiIntegrationGCal
    public GoogleDrive       : ApiIntegrationGoogleDrive

    constructor() {

        this.Stripe         = new ApiStripe();
        this.GCal           = new ApiIntegrationGCal();
        this.GoogleDrive    = new ApiIntegrationGoogleDrive()
    }


    static integrationsAll() {
        return new Request(this,'GET','company/'+gd.companyId+'/integrations/all')
    }

}


